import { render } from "./rescindSign.vue?vue&type=template&id=a0ff62e6&scoped=true&ts=true"
import script from "./rescindSign.vue?vue&type=script&lang=ts"
export * from "./rescindSign.vue?vue&type=script&lang=ts"

import "./rescindSign.vue?vue&type=style&index=0&id=a0ff62e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ff62e6"]])

export default __exports__